import { MatDialogConfig } from "@angular/material/dialog";


export const ADDR_DIALOG_OPTIONS: MatDialogConfig  = {
  minWidth: '900px',
  minHeight: '50vh',
  disableClose: true,
  panelClass: 'address-dialog-box',
}


export const ADDR_DIALOG_OPTIONS_FULLSCREEN: MatDialogConfig = {
  ...ADDR_DIALOG_OPTIONS,
  height: '100%',
  width: '100%',
  
  maxHeight: 'none',
  minHeight: 'none',
  minWidth: 'none !important',
}